import { render, staticRenderFns } from "./configlimit.vue?vue&type=template&id=65b0714b"
import script from "./configlimit.vue?vue&type=script&lang=js"
export * from "./configlimit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports